import * as React from "react";
import { cn } from "@ds/lib/utils";

/**
 * EmptyState — Capture Sheet fields 10.11, 14.8 and 22.7.
 *
 * Both instances in the source agree, including one detail that is easy to get
 * wrong: the illustration is SMALL and sits inside the content area. It does not
 * take over the screen.
 *
 * Copy shape: "No [thing] yet" → one line saying what to do → optional action
 * repeating that verb.
 */
function EmptyState({
  className,
  illustration,
  title,
  description,
  action,
}: {
  className?: string;
  illustration?: React.ReactNode;
  title: React.ReactNode;
  description?: React.ReactNode;
  action?: React.ReactNode;
}) {
  return (
    <div
      data-slot="empty-state"
      className={cn("flex flex-col items-center gap-2 px-6 py-10 text-center", className)}
    >
      {illustration ? (
        <div className="text-foreground mb-2 [&_svg]:size-10" aria-hidden>
          {illustration}
        </div>
      ) : null}
      <p className="text-row text-foreground">{title}</p>
      {description ? (
        <p className="text-support text-muted-foreground max-w-[36ch]">{description}</p>
      ) : null}
      {action ? <div className="mt-4">{action}</div> : null}
    </div>
  );
}

export { EmptyState };
